import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from "lodash";
import {
    AdminDeleteLiveStreamEventRequested,
    ClearAdminDeleteLiveStreamEvent,
    ClearGetListLiveStreamEvent,
    GetListLiveStreamEventRequested,
} from '../../../actions/LiveStreamManagement';
import {
    GetDetailCompanyRequested,
    ClearGetDetailCompany,
} from '../../../actions/AdminCompanyManagement';
import ListLiveStream from '../../../pages/Admin/CompanyManagement/ListLiveStream';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => ({
    dataListLiveStream: !_.isEmpty(state.livestream.getListLiveStream.data) && state.livestream.getListLiveStream.data.results,
    page: !_.isEmpty(state.livestream.getListLiveStream.data) && state.livestream.getListLiveStream.data.page,
    pageTotal: !_.isEmpty(state.livestream.getListLiveStream.data) && state.livestream.getListLiveStream.data.total_page,
    deleteSucces: state.livestream.deleteLiveStream,
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetListLiveStream: (params) => {
        dispatch(GetListLiveStreamEventRequested(params));
    },
    fetchClearGetListLiveStream: () => {
        dispatch(ClearGetListLiveStreamEvent());
    },
    fetchClearDeleteLiveStream: () => {
        dispatch(ClearAdminDeleteLiveStreamEvent());
    },
    fetchDeleteLiveStream: (param) => {
        dispatch(AdminDeleteLiveStreamEventRequested(param));
    },
    getDetailCompany: (params) => {
        dispatch(GetDetailCompanyRequested(params));
    },
    clearDetailComopany: () => {
        dispatch(ClearGetDetailCompany());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListLiveStream);
